import {FC, MouseEvent} from 'react'
import classnames from 'classnames'
import {CopyIconNew} from '../SvgIcon/Native'
import {TooltipWrapper, TooltipBody} from '../TooltipWrapper/TooltipWrapper'

interface CopyButtonProps {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void
  className?: string
  tooltipContent?: string
  dataCy?: string
  iconClasses?: string
  disabled?: boolean
}

export const CopyButton: FC<CopyButtonProps> = ({
  onClick,
  className = 'absolute top-4 right-2',
  tooltipContent = 'Copy button',
  dataCy,
  iconClasses = 'hover:text-white group-focus-visible:text-white',
  disabled = false,
}) => {
  const toolTipId = `copy-button-tooltip-${tooltipContent.replace(/\s+/g, '-')}`
  return (
    <>
      <TooltipWrapper id={toolTipId}>
        <TooltipBody>{tooltipContent}</TooltipBody>
      </TooltipWrapper>
      <button
        className={classnames(className, {
          'pointer-events-none opacity-50': disabled,
        })}
        onClick={onClick}
        disabled={disabled}
        data-tooltip-id={toolTipId}
        data-cy={dataCy}
        aria-label={tooltipContent}
      >
        <CopyIconNew classes={iconClasses} />
      </button>
    </>
  )
}
